import { render, staticRenderFns } from "./MemberStatistics.vue?vue&type=template&id=28c6faf3&scoped=true"
import script from "./MemberStatistics.vue?vue&type=script&lang=js"
export * from "./MemberStatistics.vue?vue&type=script&lang=js"
import style0 from "./MemberStatistics.vue?vue&type=style&index=0&id=28c6faf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c6faf3",
  null
  
)

export default component.exports